import { Page } from "@/models/page-models/Page";

export const WipTransfer: Page = {
  "path": "wip-transfer",
  "name": "WIP Transfer",
  "props": {
    "data": {
      "title": "WIP Transfer",
      "printable": "FALSE",
      "url": "wip-transfer",
      "groups": [
        {
          "groupItems": [
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "table",
                  "variable": "formData.wipTable",
                  "label": "WIP",
                  "disabled": "FALSE",
                  "items": "fetchedData.goods.data.docs",
                  "headers": [
                    {
                      "value": "__item._id",
                      "text": "Good#"
                    },
                    {
                      "value": "__item.factoryTicket._id",
                      "text": "FT #",
                      "type": "url",
                      "url": "/factory-ticket/{{__item.factoryTicket._id}}"
                    },
                    {
                      "value": "__item.name",
                      "text": "Name"
                    },
                    {
                      "value": "__item.factoryTicket.order.customer.name",
                      "text": "Customer",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,customerAlias,{{__item.factoryTicket.order.customer}})"
                    },
                    {
                      "value": "__item.factoryTicket.order.product",
                      "text": "Product Description",
                      "formula": "fn(HELPER_FN,productAlias,{{__item.factoryTicket.order.product}})"
                    },
                    {
                      "value": "__item.factoryTicket.processes",
                      "text": "Last Process",
                      "formula": "fn(HELPER_FN,lastProcess,{{__item.factoryTicket.processes}},{{__item._id}})"
                    },
                    {
                      "value": "__item.location.Factory.totalQuantity",
                      "text": "Floor Quantity",
                      "type": "formula",
                      "filterType": "unit",
                      "formula": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{__item.rawMaterialUnit}},'),==,'SQM'),{{fn(STANDARD_FUNCTIONS,kgToSQM,{{__item.location.Factory.totalQuantity}},{{__item}})}},{{__item.location.Factory.totalQuantity}})",
                      "filterParam": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{__item.rawMaterialUnit}},'),==,'SQM'),SQM,KG)",
                      "variableType": "item"
                    },
                    {
                      "value": "__item.updatedAt",
                      "text": "Date Modified",
                      "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                    },
                    {
                      "value": "__item.actions",
                      "text": "Actions",
                      "type": "actions",
                      "actions": [
                        {
                          "label": "Request Transfer",
                          "priority": "main",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "copyMaterialId"
                            },
                            {
                              "executionOrder": 1,
                              "name": "copySelectedGoodsObject"
                            },
                            {
                              "executionOrder": 2,
                              "name": "copyLocationData"
                            },
                            {
                              "executionOrder": 3,
                              "name": "getTransformedLocationsArray"
                            },
                            {
                              "executionOrder": 4,
                              "name": "openRequestsGoodsPopup"
                            }
                          ]
                        }
                      ]
                    }
                  ],
                  "tableType": "static",
                  "showActions": true,
                  "pagination": {
                    "pageVariable": "formData.page",
                    "serverItemsLengthVariable": "fetchedData.goods.data.totalDocs",
                    "pageChangeFns": [
                      {
                        "executionOrder": 3,
                        "name": "getGoods"
                      }
                    ]
                  }
                }
              ]
            }
          ],
          "type": "genericGroup"
        },
        {
          "type": "popupGroup",
          "label": "Request Goods Transfer",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.locationFrom",
                  "label": "Select Location From",
                  "disabled": "FALSE",
                  "items": "fetchedData.location.locations",
                  "itemText": "_key",
                  "itemValue": "_key"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.locationTo",
                  "label": "Select Location To",
                  "disabled": "FALSE",
                  "items": "fetchedData.location.locations",
                  "itemText": "_key",
                  "itemValue": "_key"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.quantity",
                  "label": "Enter Quantity",
                  "unit": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedGood.rawMaterialUnit}},'),==,'SQM'),SQM,KG)",
                  "disabled": "FALSE",
                  "inputType": "convert",
                  "enableConvertFnFlag": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.selectedGood.rawMaterialUnit}},'),==,'SQM')",
                  "convertFn": "sqmToKg",
                  "goodsId": "{{formData.rawMaterial}}"
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Submit",
              "onClick": [
                {
                  "executionOrder": 1,
                  "name": "submitGoodsTransferRequest"
                },
                {
                  "executionOrder": 2,
                  "name": "closeRequestsGoodsPopup"
                }
              ]
            }
          ]
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultPageNo",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultPageNo",
          "arg2Key": "destinationKey",
          "arg2Value": "formData",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyDefaultPageNo"
      },
      {
        "executionOrder": 3,
        "name": "getGoods"
      }
    ],
    "functions": [
      {
        "name": "getGoods",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/goods/factory-wip",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.goods",
        "arg3Key": "postData",
        "arg3Value": "formData"
      },
      {
        "name": "getDefaultPageNo",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": "1"
        },
        "useFormula": true
      },
      {
        "name": "copyMaterialId",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__item._id",
        "arg2Key": "destinationKey",
        "arg2Value": "formData.rawMaterial"
      },
      {
        "name": "copyLocationData",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__item.location",
        "arg2Key": "sourceFn",
        "arg2Value": "getLocationsArray",
        "arg3Key": "destinationKey",
        "arg3Value": "fetchedData.location"
      },
      {
        "name": "getLocationsArray",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "locations": "fn(TO_ARRAY,{{__selectedObject}})"
        },
        "useFormula": true
      },
      {
        "name": "copySelectedGoodsObject",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__item",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.selectedGood"
      },
      {
        "name": "openRequestsGoodsPopup",
        "type": "fnOpenPopup",
        "arg1Key": "popupName",
        "arg1Value": "Request Goods Transfer"
      },
      {
        "name": "closeRequestsGoodsPopup",
        "type": "fnClosePopup",
        "arg1Key": "popupName",
        "arg1Value": "Request Goods Transfer"
      },
      {
        "name": "submitGoodsTransferRequest",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/goods/transfer/request",
        "arg2Key": "postData",
        "arg2Value": "formData",
        "arg3Key": "refreshPage",
        "arg3Value": "TRUE"
      },
      {
        "name": "copyDefaultFGFormValues",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getDefaultFormValues",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData",
        "arg3Key": "destinationKeyType",
        "arg3Value": "Object",
        "arg4Key": "append",
        "arg4Value": "TRUE"
      },
      {
        "name": "getDefaultFormValues",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "unitOfTransfer": "{{fetchedData.sellingUnits.options.0}}",
          "locationTo": "Warehouse",
          "locationFrom": "Factory"
        },
        "useFormula": true
      }
    ]
  },
  "forRole": "PRODUCTION_MANAGER,PRODUCTION_PLANNER",
  "visible": true,
  "routerPriority": 70
}